import useActionFactory from '@nicolaudie-group/ng-ui-kit/composables/useActionFactory'

import { startHandler, errorHandler, finishHandler } from '@/helpers/actionHandlers'

const useAction = useActionFactory({
  startHandler,
  errorHandler,
  finishHandler,
})

export default useAction
